import Vue from 'vue';
import Vuex from 'vuex';
// Stores
import chapters from './chapters';
import stories from './stories';
import quiz from './quiz';
import exhibitions from './exhibitions';
import user from './user';
import users from './users';
import terms from './terms';
import signup from './signup';
import login from './login';
import lostpassword from './lostpassword';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    chapters,
    stories,
    quiz,
    exhibitions,
    user,
    users,
    terms,
    signup,
    login,
    lostpassword
  },
});
